/*
 * Fragment Block
 * Include content on a page as a fragment.
 * https://www.aem.live/developer/block-collection/fragment
 */
import { loadBlocks } from 'scripts/aem.js';
import { decorateMain } from 'scripts/scripts.js';
import { getOrigin } from 'utils/window-utils.ts';
import './fragment.css';

/**
 * Loads a fragment.
 * @param {string} path The path to the fragment
 * @returns {HTMLElement} The root element of the fragment
 */
export async function loadFragment(path: string | null | undefined) {
	if (path && path.startsWith('/')) {
		const resp = await fetch(`${path}.plain.html`);
		if (resp.ok) {
			const main = document.createElement('main');
			main.innerHTML = await resp.text();

			const origin = getOrigin();

			// reset base path for media to fragment base
			main.querySelectorAll(`img[src^="./media_"]`).forEach((elem) => {
				const imageElement = elem as HTMLImageElement;
				imageElement.src = new URL(
					imageElement.getAttribute('src')!,
					new URL(path, origin),
				).href;
			});
			main.querySelectorAll(`source[srcset^="./media_"]`).forEach((elem) => {
				const sourceElement = elem as HTMLSourceElement;
				sourceElement.srcset = new URL(
					sourceElement.getAttribute('srcset')!,
					new URL(path, origin),
				).href;
			});

			decorateMain(main, true);
			await loadBlocks(main);
			return main;
		}
	}
	return null;
}

export default async function decorate(block: Element) {
	const link = block.querySelector('a');
	const path = link ? link.getAttribute('href') : block.textContent?.trim();
	const fragment = await loadFragment(path);
	if (fragment) {
		const fragmentSection = fragment.querySelector(':scope .section');
		if (fragmentSection) {
			block
				.closest('.section')
				?.classList.add(...Array.from(fragmentSection.classList));
			block
				.closest('.fragment')
				?.replaceWith(...Array.from(fragment.childNodes));
		}
	}
}
